import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoryNav() {
  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-8">
            分类浏览
          </h2>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 md:gap-4">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="flex items-center gap-3 bg-background-100 hover:bg-background-200/70 rounded-xl px-4 py-4 transition-all duration-300 hover:-translate-y-0.5 cursor-pointer group"
              >
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-700 group-hover:bg-accent-500 group-hover:text-background-50 transition-colors">
                  <i className={`${cat.icon} text-lg`}></i>
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-950 whitespace-nowrap">{cat.name}</p>
                  <p className="text-xs text-foreground-500">{cat.count}部</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}